import styled from 'styled-components'

export const Header = styled.div`
    background-color: var(--gray-100);
    height: 44px;

    div {
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        font-size: 11px;
        line-height: 44px;
        letter-spacing: normal;
        color: var(--gray-600);
        text-transform: uppercase;
    }
`

export const Row = styled.div`
    background-color: var(--gray-0);
    margin-bottom: 12px;
    border-radius: 4px;
    box-shadow: 0 4px 10px 0 rgba(14, 77, 140, 0.1);
    border: solid 1px rgba(14, 77, 140, 0.2);
`

export const Columns = styled.div`
    height: 40px;
    display: flex;
    align-items: center;
`

export const Column = styled.div`
    flex: 1;
    font-size: 12px;
    color: var(--gray-700);
`

export const Details = styled.div`
    .aggregations-title {
        font-family: SourceSansPro-Semibold;
        color: rgb(54, 65, 89);
    }

    .aggregations-refresh-status {
        display: block;
        margin-bottom: 20px;

        &:hover {
            text-decoration: none;
        }
    }

    .aggregations-query {
        padding: 20px;
        box-shadow: rgba(54, 65, 89, 0.2) 0px 0px 5px 0px;
        border: 1px solid rgb(221, 222, 225);
        border-radius: 3px;

        h3 {
            font-family: SourceSansPro-Semibold;
            color: rgb(54, 65, 89);
            margin: 0;
        }

        pre {
            margin-top: 0;
            padding: 8px;
            border: 1px solid #ddd;
        }

        label,
        .btn.btn-primary {
            margin-top: 16px;
        }
    }
`

export const Action = styled.button`
    margin-right: 8px;

    &.btn {
        border-color: #eee;
        color: #37a3ef;

        &:not(.btn-primary):hover {
            background-color: #f1f1f1;
        }
    }

    &.btn.btn-primary {
        border-color: #008ac7;
        color: #fff;
    }

    &:focus {
        outline: none;
    }
`

export const Actions = styled.div`
    padding: 0 0 8px;
`

export const LastEvent = styled.div`
    .fromNow {
        margin-left: 4px;
        font-size: 11px;
        font-weight: 600;
        color: #616a81;
    }
`

export const NoAggregations = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50%;
    font-size: 14px;
`

export const Loading = styled.div`
    line-height: 18px;
    min-height: 0px;
    max-width: 100%;
    height: 100%;
    flex: 1 1 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10%;
    font-size: 30px;
    color: rgb(134, 134, 149);
    font-family: SourceSansPro-Light;
`

export const Cancel = styled.a`
    margin-left: 0;
`

export const CalendarAdjusted = styled.div`
 > * {
    left: auto;
    top:auto;
 }
`
export const WarningText = styled.div`
    background-color: #f0ad4e;
`
